import * as React from 'react';
import 'isomorphic-fetch';
export class PersonSummary extends React.Component {
    constructor() {
        super();
        this.state = {};
    }
    render() {
        return React.createElement("div", null, "Welcome to 2KVIZ Administration Panel");
    }
}
//# sourceMappingURL=PersonSummary.js.map


//////////////////
// WEBPACK FOOTER
// ./ClientApp/MyPage/PersonSummary.js
// module id = 96
// module chunks = 0